import {
  Card,
  CardWrapper,
  Heading,
  HeadingWrapper,
  HeroContainer,
  SubTitle
} from './HeroFold.styles';
import VehicleEntry from './VehicleEntry';
import { headerCopy, subHeaderCopy } from './HeroFold.content';

const HeroFold = () => (
  <HeroContainer>
    <HeadingWrapper>
      <Heading>{headerCopy}</Heading>
      <SubTitle style={{ whiteSpace: 'pre-wrap' }}>{subHeaderCopy}</SubTitle>
    </HeadingWrapper>
    <CardWrapper>
      <Card>
        <VehicleEntry />
      </Card>
    </CardWrapper>
  </HeroContainer>
);

export default HeroFold;
